<template>
  <div class="is-marginless is-paddingless section section-details"
    v-if="societe">
    <div class="entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('societes.titreModifier', { nom: this.libelle }) }}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <button class="button is-cancel btn-modal-annuler" @click="$router.go(-1)">
              {{ $t('societes.annuler') }}
            </button>
            <button class="button is-addOrEdit"
              @click="sauvegarderSociete()">
              {{ $t('general.button.sauvegarder') }}
            </button>
            <a class="button"
              @click="showAddAttachmentModal()">
              <b-icon
                icon="paperclip"
                type="is-default">
              </b-icon>
            </a>
          </div>
        </div>
      </div>
      <error-msg-component :messages="messages"
                           :error="error"
                           :messagesChampsVide="messagesChampsVide"
                           :champsVide="champsVide"
                           :title="'editionClient.problemOccurred'"
                           :withEmplyFields="true"
                           @close="error = $event"/>
      <div class="tab">
        <ul>
          <li :class="{'is-active': activeTab === 'tab-societe'}"
              @click="activeTab = 'tab-societe'">
            {{ $t('societes.tab.societe') }}
          </li>
          <li :class="{'is-active': activeTab === 'tab-comptabilite'}"
              @click="activeTab = 'tab-comptabilite'">
            {{ $t('societes.tab.comptabilite') }}
          </li>
          <li :class="{'is-active': activeTab === 'tab-fonctionnement'}"
              @click="activeTab = 'tab-fonctionnement'">
            {{ $t('societes.tab.fonctionnement') }}
          </li>
          <li :class="{'is-active': activeTab === 'texte-edition'}"
              @click="activeTab = 'texte-edition'">
            {{ $t('societes.tab.edition') }}
          </li>
          <li :class="{'is-active': activeTab === 'tab-vente-interne'}"
              @click="activeTab = 'tab-vente-interne'"
              v-if="hasHolding">
            {{ $t('societes.tab.configVenteInterne') }}
          </li>
          <li :class="{'is-active': activeTab === 'tab-logistique'}"
              @click="activeTab = 'tab-logistique'">
            {{ $t('societes.tab.logistique') }}
          </li>
          <li :class="{'is-active': activeTab === 'tab-stock'}" v-if="moduleStockTiersActive"
              @click="activeTab = 'tab-stock'">
            {{ $t('societes.tab.stock') }}
          </li>
          <li :class="{'is-active': activeTab === 'tab-mentions-legales'}"
              @click="activeTab = 'tab-mentions-legales'">
            {{ $t('societes.tab.mentionsLegales') }}
          </li>
          <li v-if="moduleSignatureElectroniqueActive"
              :class="{'is-active': activeTab === 'tab-signature-electronique'}"
              @click="activeTab = 'tab-signature-electronique'">
            {{ $t('societes.tab.signatureElectronique') }}
          </li>
          <li v-if="moduleLogistiqueImpressionActive"
              :class="{'is-active': activeTab === 'tab-logistique-impression'}"
              @click="activeTab = 'tab-logistique-impression'">
            {{ $t('societes.tab.logistiqueImpression') }}
          </li>
        </ul>
      </div>
    </div>
    <div>
      <component
        :is="activeTab"
        :societe="societe" />
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { get, update } from '@/api/societe/index';
import { get as getSchema } from '@/api/schemaComptable/index';
import AppBreadcrumb from '@/components/general/breadcrumb';
import messageSucces from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import validationSociete from '@/services/parametrage/validation/validationSociete';
import * as types from '@/store/modules/societe-mutation-type';
import TabComptabilite from '@/components/parametrage/societes/m_societeComptaTab';
import TabSociete from '@/components/parametrage/societes/m_societeTab';
import TabFonctionnement from '@/components/parametrage/societes/ajoutEditionSociete/m_fonctionnement';
import TabVenteInterne from '@/components/parametrage/societes/ajoutEditionSociete/m_venteInterne';
import TabMentionsLegales from '@/components/parametrage/societes/m_societeMentionsLegalesTab';
import TabSignatureElectronique from '@/components/parametrage/societes/m_societeSignatureElectroniqueTab';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import validation from '@/services/validation/validation';
import translate from '@/services/parametrage/translator/translatorSociete';
import texteEdition from '@/components/parametrage/societes/ajoutEditionSociete/m_texteEdition';
import { siteHasHolding } from '@/services/general/holding';
import { TYPE_HOLDING } from '@/configuration/societe/societe';
import TabLogistique from '@/components/parametrage/societes/ajoutEditionSociete/m_logistique';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import TabStock from '@/components/parametrage/societes/ajoutEditionSociete/m_stock';
import TabLogistiqueImpression from '@/components/parametrage/societes/ajoutEditionSociete/logistiqueImpression/m_logistiqueImpression';

const user = createNamespacedHelpers('user');
const societe = createNamespacedHelpers('societe');
const Attachments = createNamespacedHelpers('attachments');
const Parametres = createNamespacedHelpers('parametres');

export default {
  components: {
    AppBreadcrumb,
    TabComptabilite,
    TabSociete,
    TabFonctionnement,
    TabSignatureElectronique,
    errorMsgComponent,
    texteEdition,
    TabVenteInterne,
    TabLogistique,
    TabStock,
    TabMentionsLegales,
    TabLogistiqueImpression,
  },
  data() {
    return {
      societe: null,
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      activeTab: 'tab-societe',
      libelle: '',
    };
  },
  computed: {
    ...user.mapGetters({
      utilisateur: 'user',
    }),
    ...societe.mapGetters({
      societeCourante: 'societeCourante',
      societeActiveId: 'societeActiveId',
      existHolding: 'existHolding',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    hasHolding() {
      return siteHasHolding() || this.societe.typeSociete === TYPE_HOLDING;
    },
    moduleSignatureElectroniqueActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.signatureElectronique.key);
    },
    breadcrumb() {
      return [
        { title: this.$i18n.t('listeUtilisateur.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeUtilisateur.parametrage'), route: { name: 'l.parametrage.general' }, isActive: false },
        { title: this.$i18n.t('societes.liste'), route: { name: 'l.parametrage.societe/agence' }, isActive: false },
        { title: this.$i18n.t('societes.modifier'), route: { name: 'm.parametrage.societe/agence' }, isActive: true },
      ];
    },
    moduleStockTiersActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleStockTiers.key);
    },
    moduleLogistiqueImpressionActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleLogistiqueImpression.key);
    },
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
      showAddAttachmentModal: 'showAddModal',
      updateAttachments: 'update',
    }),
    ...societe.mapActions({
      actionSetSocieteOfUser: 'setSocieteOfUser',
      loadSocietes: 'loadSocietes',
    }),
    ...societe.mapMutations({
      setSocieteCourante: types.SET_SOCIETE_COURANTE,
      setSocieteActive: types.SET_SOCIETE_ACTIVE,
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    async sauvegarderSociete() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.error = false;
        this.messages = [];
        this.messagesChampsVide = [];
        this.champsVide = [];
        const societe = (await update(this.societe)).data.result;
        await this.updateAttachments(this.$route.params.id);
        await this.loadSocietes({});
        await this.actionSetSocieteOfUser(this.utilisateur);
        if (this.societeActiveId === societe.id) this.setSocieteActive(societe);
        messageSucces(this.$i18n.t('societes.messages.modifSuccess'));
        await this.$router.push({ name: 'c.parametrage.societe/agence' });
        loadingComponent.close();
      } catch (e) {
        if (e.response && e.response.data.error) {
          validationSociete(e.response, this.messages);
          validation(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (!['m.parametrage.societe/agence-ajoutAgence', 'm.parametrage.societe/agence-ajoutAgenceFromSociete', 'm.parametrage.societe/agence-modificationAgence'].includes(to.name)) {
      this.setSocieteCourante(null);
    }
    next();
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.setAttachmentContext({ module: 'Societe' });
      await this.setAttachmentContext({ module: 'SignatureElectronique' });
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.moduleStockTiers.key,
        PARAMETRES_INTERNE_KEYS.moduleLogistiqueImpression.key,
      ]);
      this.societe = (await get(this.$route.params.id)).data.result;
      this.libelle = cloneDeep(this.societe.libelle);
      this.setInformationPage(this.$t('pageGeneral.modification', { item: this.societe.libelle }));
      await this.setAttachmentElementId({ id: this.$route.params.id });
      this.societe.agences.sort((a, b) => {
        return a.libelle.localeCompare(b.libelle);
      });
      if (this.societeCourante !== null) {
        this.societe = this.societeCourante;
        this.setSocieteCourante(null);
      } else {
        // C'est certainement idiot de le faire là mais vu le if bizarre au dessus
        // je ne prends pas de risque

        if (this.societe.schemaComptableIdAcompteFacturation) {
          this.societe.schemaComptableFacturation = (await getSchema(
            this.societe.schemaComptableIdAcompteFacturation,
          )).data.result;
        }
        if (this.societe.schemaComptableIdAcompteExtourne) {
          this.societe.schemaComptableExtourne = (await getSchema(
            this.societe.schemaComptableIdAcompteExtourne,
          )).data.result;
        }
      }
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
